import { render, staticRenderFns } from "./membersStatistics.vue?vue&type=template&id=8bb62f7a&scoped=true&"
import script from "./membersStatistics.vue?vue&type=script&lang=js&"
export * from "./membersStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb62f7a",
  null
  
)

export default component.exports